import React from 'react';
import PropTypes from 'prop-types';
import ImageCard from './ImageCard';

function ImageList(props) {
    return (
        <>
            {props.images &&
                props.taxonomy &&
                props.images.map((image) => {
                    {
                        return (
                            <ImageCard
                                key={image._id}
                                data={image}
                                imageId={image.imageId}
                                taxonomy={props.taxonomy}
                            />
                        );
                    }
                })}
        </>
    );
}

ImageList.propTypes = {
    taxonomy: PropTypes.object,
    images: PropTypes.arrayOf(PropTypes.object),
};

ImageList.defaultProps = {
    taxonomy: {
        object: [],
        material: [],
        brand: [],
    },
    images: [],
};

export default ImageList;
